import { render, staticRenderFns } from "./FormTrazabilidad.vue?vue&type=template&id=e2938012&scoped=true&"
import script from "./FormTrazabilidad.vue?vue&type=script&lang=js&"
export * from "./FormTrazabilidad.vue?vue&type=script&lang=js&"
import style0 from "./FormTrazabilidad.vue?vue&type=style&index=0&id=e2938012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2938012",
  null
  
)

export default component.exports